/*** IMPORTS FROM imports-loader ***/
var define = false;

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function storyScroll() {
  // any element with animateOnLoad class
  // this way would then let you handle animation in css
  ScrollTrigger.batch(".story__section", {
    toggleClass: "inView",
    // once: true,
    start: "top 65%"
  });

  gsap.to('.story__timeline', {
    scrollTrigger: {
      trigger: ".story",
      scrub: 1,
      start: 'top 50%',
      end: 'bottom 20%',
      // markers: true,
    },
    height: '100%',
  });
}
